import type { ComputedRef } from 'vue';
import { computed } from 'vue';
import { listDictionaries } from '@/api/system/dictionary';
import { RParam } from '@/api';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/modules/user';
import { listDictionaryData } from '@/api/system/dictionary-data';
import type { TenantDictData } from '@/api/bsl/tenant/dict/types';

/**
 * 获取字典数据hook
 * @param codes 字典编码
 */
export function useDictData(codes: string[]): ComputedRef<TenantDictData[]>[] {
  const result: ComputedRef<TenantDictData[]>[] = [];

  // 已缓存的字典
  const userStore = useUserStore();
  const { dicts } = storeToRefs(userStore);

  codes.forEach((code) => {
    result.push(computed<TenantDictData[]>(() => dicts.value[code] || []));
    // 若还未缓存过则获取字典数据
    if (dicts.value[code] != null) {
      return;
    }
    userStore.setDicts([], code);

    // 查询字典数据
    listDictionaries({
      where: RParam.buildWhere({ dictCode: code })
    }).then((data) => {
      if (data) {
        const dictSeqs = data.map((item) => item.seq);
        const dictionaryMap = new Map<number, any>();
        data.forEach((item) => {
          dictionaryMap.set(item.seq!, item);
        });
        if (dictSeqs.length) {
          listDictionaryData({
            where: RParam.buildWhere({ dictSeq: dictSeqs })
          }).then((data) => {
            if (data) {
              const list: any = [];

              data.forEach((item) => {
                const dictionary = dictionaryMap.get(item.dictSeq!);
                if (dictionary) {
                  list.push(item);
                }
              });
              userStore.setDicts(list, code);
            }
          });
        }
      }
    });
  });

  return result;
}
